import { Pagador } from 'src/app/pago/models/Pagador.model';

export class PagadorBuilder {
  private nombres: string;
  private apellidos: string;
  private tipoDocumento: string;
  private numeroDocumento: string;
  private ciudad: string;
  private departamento: string;
  private direccion: string;
  private pais: string;
  private correoElectronico: string;
  private telefono: string;
  private celular: string;

  withNombres(nombres: string) {
    this.nombres = nombres;
    return this;
  }

  withApellidos(apellidos: string) {
    this.apellidos = apellidos;
    return this;
  }

  withTipoDocumento(tipoDocumento: string) {
    this.tipoDocumento = tipoDocumento;
    return this;
  }

  withNumeroDocumento(numeroDocumento: string) {
    this.numeroDocumento = numeroDocumento;
    return this;
  }

  withCiudad(ciudad: string) {
    this.ciudad = ciudad;
    return this;
  }

  withDepartamento(departamento: string) {
    this.departamento = departamento;
    return this;
  }

  withDireccion(direccion: string) {
    this.direccion = direccion;
    return this;
  }

  withPais(pais: string) {
    this.pais = pais;
    return this;
  }

  withCorreoElectronico(correoElectronico: string) {
    this.correoElectronico = correoElectronico;
    return this;
  }

  withTelefono(telefono: string) {
    this.telefono = telefono;
    return this;
  }

  withCelular(celular: string) {
    this.celular = celular;
    return this;
  }

  build(): Pagador {
    return {
      nombres: this.nombres,
      apellidos: this.apellidos,
      tipoDocumento: this.tipoDocumento,
      numeroDocumento: this.numeroDocumento,
      ciudad: this.ciudad,
      departamento: this.departamento,
      direccion: this.direccion,
      pais: this.pais,
      correoElectronico: this.correoElectronico,
      telefono: this.telefono,
      celular: this.celular,
    };
  }
}
